import MobileChatListView from './MobileChatListView';
import OnelivePageLayout from './OnelivePageLayout';
import { useChatListPage } from './useChatListPage';
import { useOneliveDesktop } from './useOneliveDesktop';

/** 채팅방 목록 — PC/모바일 동일 UI (진행중인 채팅 + 채팅방 리스트) */
export default function MobileChatListPage() {
  const state = useChatListPage();
  const isDesktop = useOneliveDesktop();
  const pageClassName = [
    isDesktop ? 'onelive-desktop-chat-page onelive-chat-desktop-view' : 'onelive-mobile-chat-page onelive-chat-mobile-view',
    'onelive-chat-list-page',
  ].join(' ');

  return (
    <OnelivePageLayout pageClassName={pageClassName}>
      <MobileChatListView {...state} />
    </OnelivePageLayout>
  );
}
